"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireWildcard(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _tracking = require("@site/pattern-library-utils/tracking");
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
var _text = _interopRequireDefault(require("@ux/text"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const CardWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardWrapper",
  class: "pl-c16i8b21"
});
const CardInner = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "CardInner",
  class: "pl-c1flqtqq",
  vars: {
    "c1flqtqq-0": [({
      backgroundColor
    }) => backgroundColor ?? `${_intents.default.ux.boxLowContrast.backgroundColor}`],
    "c1flqtqq-5": [({
      landscape
    }) => landscape ? `url(${landscape})` : 'initial']
  }
});
const ContentGroup = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentGroup",
  class: "pl-c1g5ya4u"
});
const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c184f6ou"
});
const ArrowButton = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ArrowButton",
  class: "pl-a1qrcvvh"
});

/**
 * Product Card Item Component.
 *
 * @param {Object} props React props
 * @param {Object} props.portrait The portrait object containing the URL of the image.
 * @param {Object} props.tablet The tablet object containing the URL of the image.
 * @param {Object} props.landscape The landscape object containing the URL of the image.
 * @param {String} props.backgroundColor The background color of the card.
 * @param {Boolean} props.invert Invert the text color
 * @param {String} props.partial Theme partial for card item
 * @param {Array} props.ctas Headline Lockup Cta
 * @param {String} props.heading The heading of the card.
 * @param {String} props.description The description of the card.
 * @param {String} props.tagLabel The label of the tag.
 * @param {String} props.labelDesign The design of the label.
 * @param {Boolean} props.newMobileLayout New mobile layout for the cards
 * @returns {React.ReactElement} Product Card Item Component
 * @public
 */
function ProductCardItem({
  portrait,
  tablet,
  landscape,
  backgroundColor = {
    intent: 'ux.boxLowContrast.backgroundColor'
  },
  invert = false,
  ctas,
  partial,
  heading,
  description,
  tagLabel,
  labelDesign,
  newMobileLayout = false
}) {
  const cardRef = (0, _react.useRef)();
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const button = ctas?.length > 0 ? ctas[0] : null;
  const {
    ctaRef
  } = (0, _tracking.useTrackingUpdate)(button);
  const tabletFallbackUrl = !newMobileLayout ? portrait?.url : landscape?.url;
  const backgroundImages = {
    portrait: portrait?.url,
    tablet: tablet?.url ? tablet?.url : tabletFallbackUrl,
    landscape: landscape?.url
  };
  const handleClick = e => {
    if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
      e.stopPropagation();
      const elementToClick = (0, _patternLibraryUtils.getClickable)({
        ref: cardRef
      });
      (0, _patternLibraryUtils.handleModifierKeyAnchorClick)(e, elementToClick);
    }
  };
  return /*#__PURE__*/_react.default.createElement(CardWrapper, {
    "data-cy": "product-card-item",
    ref: cardRef,
    className: "product-card-item",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(Container, {
    ref: ctaRef
  }, /*#__PURE__*/_react.default.createElement(CardInner, (0, _extends2.default)({
    "data-cy": "card-inner",
    backgroundColor: (0, _intents.getBackgroundColor)(backgroundColor),
    portrait: !!portrait,
    landscape: !!landscape,
    "data-partial": partial || (invert ? 'dark1' : ''),
    breakOn: "mobile",
    imgLoading: width !== 0 && (width > _breakpoints.size.ipadPro ? 'lazy' : 'eager') || 'lazy'
  }, backgroundImages), /*#__PURE__*/_react.default.createElement(ContentGroup, {
    className: "text-group",
    "data-cy": "text-group"
  }, tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    dataCy: "card-tag",
    className: "card-tag",
    text: tagLabel,
    design: labelDesign
  }), heading && /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    size: 1,
    text: heading,
    className: "card-heading"
  }), description && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    text: description,
    className: "card-description"
  }), ctas && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "cta-container",
    className: "cta-container"
  }, /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctas?.map(cta => ({
      ...cta,
      size: 'small'
    }))
  }))), /*#__PURE__*/_react.default.createElement(ArrowButton, {
    "data-cy": "arrow"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "link-arrow"
  })))));
}
var _default = exports.default = ProductCardItem;
ProductCardItem.propTypes = {
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  backgroundColor: _propTypes.default.object,
  invert: _propTypes.default.bool,
  ctas: _propTypes.default.arrayOf(_propTypes.default.object),
  partial: _propTypes.default.string,
  heading: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  newMobileLayout: _propTypes.default.bool
};